var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSearch = function SvgIcSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.639 7.11a5.472 5.472 0 1 1 10.944 0 5.472 5.472 0 0 1-10.944 0ZM7.11.14a6.972 6.972 0 1 0 4.371 12.404l3.099 3.098a.75.75 0 1 0 1.06-1.06l-3.098-3.099A6.972 6.972 0 0 0 7.11.138Z"
  })));
};
export default SvgIcSearch;